module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAaklEQVRIS2NkIAAcun//R1ZyoJSVkZAefPIENY9aSGrwjgYpw2iiIZRo0EOI5olm4C0klCgIyZMcpIQMJCQ/aiFGoiEUZITkR4OU6kFKKMhHLWRAbySRGmSE9DNS28BRC0eDlGAjitREBwAQlhOQZiT3KgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/playStyle.png
// module id = PPhj
// module chunks = 1